import { Stack } from '@mui/material';
import styled from 'styled-components';

export const JobLogsTitleContainer = styled(Stack)`
  && {
    flex-direction: row;
    gap: 0.75rem;
    align-items: center;

    & > svg {
      color: ${({ theme }) => theme.palette.primary.main};
      width: 1.5rem;
      height: 1.5rem;
    }
  }
`;
